/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconBurgerMenu16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconBurgerMenu16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path d="M2 4h12v1.333H2V4ZM2 7.333h12v1.334H2V7.333ZM2 10.667h12V12H2v-1.333Z" fill="currentColor" />
        </SVGContainer>
    );
});

const IconBurgerMenu24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconBurgerMenu24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path d="M3 6h18v2H3V6ZM3 11h18v2H3v-2ZM3 16h18v2H3v-2Z" fill="currentColor" />
        </SVGContainer>
    );
});

export const IconBurgerMenu = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconBurgerMenu(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '16':
            return <IconBurgerMenu16 {...iconProps} />;
        case '24':
            return <IconBurgerMenu24 {...iconProps} />;
        default:
            return <IconBurgerMenu24 {...iconProps} />;
    }
});
